import React from 'react';

/**
 * Whether the text inside `ref` is clipped. Call `measure` from the tooltip's `onOpen`, so the check
 * runs at hover time, after fonts and layout have settled.
 */
export const useIsTextTruncated = <T extends HTMLElement>(
  ref: React.RefObject<T | null>
): { isTruncated: boolean; measure: () => void } => {
  const [isTruncated, setIsTruncated] = React.useState(false);

  // Sub-pixel widths: scrollWidth and clientWidth round, which hides an overflow of about a pixel.
  const measure = React.useCallback((): void => {
    const element = ref.current;
    if (!element || typeof document.createRange().getBoundingClientRect !== 'function') {
      return;
    }
    const range = document.createRange();
    range.selectNodeContents(element);
    setIsTruncated(range.getBoundingClientRect().width > element.getBoundingClientRect().width + 0.5);
  }, [ref]);

  return { isTruncated, measure };
};
